<template>
<!-- open setup folder where the darsh.css  is located inside component -->
   <div class="wrapper">
        <!-- Sidebar  -->
        <nav id="sidebar" class="bg-light">
            <div class="sidebar-header bg-light">
                <div class="text-center">
                    <img src="../assets/webitscure-logo.png" alt="" class="img-web">
                    <div class="text-head">
                       <h6>webiTscure</h6>  
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="green">
                    <div>

                    </div>
                </div>
            </div>
            <ul class="list-unstyled components mt-n3">
                <p>Dummy Heading</p>
                <li class="active">
                    <router-link to="/card" class="p-3">
                    <span class="fa fa-home p-2"></span>
                    Dashboard</router-link>
                </li>
                <li>
                    <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle p-3"> 
                        <span class="p-2"><i class="fa fa-pencil "></i></span>  
                        Create
                    </a>
                    <div id="homeSubmenu" class="collapse">
                         <a href="#emailSubmenu" data-toggle="collapse" aria-expanded="true" class="dropdown-toggle p-3"><span class="fa fa-envelope p-2"></span> Email</a>
                        <ul class="collapse list-unstyled" id="emailSubmenu">
                            <li>
                                <router-link to="/regular">Regular</router-link>
                            </li>
                            <li>
                                <a href="#">Plaint Text</a>
                            </li>
                            
                        </ul>
                    </div>
                </li>
                <li>
                <a href="#" class=""> <span class="fa fa-users p-2"></span>Tags</a>
                </li>
                <li>
                    <router-link to="/contact" class="p-3"><i class="material-icons">contacts</i> Contact</router-link>
                </li>
            </ul>

        </nav>

        <!-- Page Content  -->
        <div id="content">

            <nav class="navbar navbar-expand-lg navbar-light bg-light">
                <div class="container-fluid">

                    <button type="button" id="sidebarCollapse" class="btn btn-info" >
                        <i class="fas fa-align-left"></i>
                        <!-- <span>Toggle Sidebar</span> -->
                    </button>
                    <!-- <button class="btn btn-dark d-inline-block d-lg-none ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <i class="fas fa-align-justify"></i>
                    </button> -->

                    <!-- <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="nav navbar-nav ml-auto">
                            <li class="nav-item active">
                                <a class="nav-link" href="#">Page</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#">Page</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#">Page</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#">Page</a>
                            </li>
                        </ul>
                    </div> -->
                </div>
            </nav>
            <!-- Add content here -->
            <router-view></router-view>
            <!-- <div class="line"></div> -->
            <!--  -->

          
        </div>
    </div>
</template>

<style lang="css" src="./setup/dash.css" scoped></style>